import {Component, Input, OnInit} from '@angular/core';
import {Slavnost} from '../model/slavnost';
import {AppService} from '../app.service';
import { HttpClient } from '@angular/common/http';
import {Studium} from '../model/studium';

@Component({
    selector: 'app-slavnosti',
    templateUrl: './slavnosti.component.html',
    styleUrls: ['./slavnosti.component.css'],
    standalone: false
})
export class SlavnostiComponent implements OnInit {

  @Input()
  data: Slavnost[];

  @Input()
  studium: Studium;

  show = true;

  constructor(private appService: AppService, private http: HttpClient) { }

  ngOnInit() {
  }

  headerClick() {
    this.show = !this.show;
  }

  appOpen() {
    this.appService.openPortalAppWindow(
      'ais.gui.vs.es.slavnosti.VSES305_StudentPrihlasenieSaNaSlavnostDlg',
      this.studium.id
      );
  }

}
